import type { ApiFetchOfficialProfilesPort } from '~/handlers/ports/api-fetch-official-profiles.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

export class ApostatudoApiFetchOfficialProfilesAdapter
  implements ApiFetchOfficialProfilesPort
{
  async handle(): Promise<OfficialProfileListItem[]> {
    const response = await fetch(`${getApostatudoApiUrl()}/official-profiles`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      console.warn(
        `[ApiFetchOfficialProfiles] API retornou ${response.status}: ${response.statusText}`,
      );

      return [];
    }

    const json: OfficialProfileListApiResponse = await response.json();

    if (!Array.isArray(json?.data)) {
      console.warn(
        '[ApiFetchOfficialProfiles] Resposta não é uma lista:',
        json,
      );

      return [];
    }

    // O core já ordena por `position`; reordenar aqui evita depender disso.
    return [...json.data].sort((a, b) => a.position - b.position);
  }
}
